/* raw layout hash: auth-web-layout:79c1b2355b07836c6cf770ea95abb5491687739cc5ad468393457c012afbf174 */
import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Public authentication shell — RawHTMLDesign/layouts/auth-web-layout.html.
 * Full-height dark backdrop with no navbar/menu (the design carries only a
 * hidden brand marker); used for the anonymous-access pages (login,
 * password reset). The page content itself renders the "MarginOS" brand and
 * any sign-in-with-account chrome — this shell intentionally adds none, to
 * match the reference exactly.
 */
export default function AuthWebLayout() {
  return (
    <div className="app-shell-auth">
      <div className="company-name-holder">MarginOS</div>

      <Outlet />
    </div>
  );
}
